import { FC } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import classnames from "classnames";
import debounce from "@mui/utils/debounce";

function noop() {}

interface HeroButtonProps {
  loading?: boolean;
  disabled?: boolean;
  [key: string]: any;
}

function Bg() {
  return (
    <div className="ui__hero_button__bg absolute left-0 top-0 w-full h-full bg-hero rounded-full" />
  );
}

function HoverBg() {
  return (
    <div className="ui__hero_button__hover_bg absolute left-0 top-0 w-full h-full bg-hero-hover rounded-full" />
  );
}

function LoadingBg() {
  return (
    <div className="ui__hero_button__loading_bg absolute left-0 top-0 w-full h-full bg-hero-loading rounded-full" />
  );
}

const HeroButton: FC<HeroButtonProps> = ({
  className,
  children,
  loading,
  disabled,
  onClick,
  ...restProps
}) => {
  return (
    <button
      className={classnames(
        "ui__hero_button text-white relative rounded-full overflow-hidden font-medium",
        { "ui__hero_button--loading": loading },
        { "ui__hero_button--disabled": disabled },
        className
      )}
      disabled={disabled}
      onClick={disabled || loading ? null : debounce(onClick || noop, 300)}
      {...restProps}
    >
      <HoverBg />
      {loading && <LoadingBg />}
      <Bg />
      <div className="content relative z-[1] flex justify-center items-center">
        {loading && (
          <span className="mr-[8px]">
            <CircularProgress color="inherit" size={16} />
          </span>
        )}
        {children}
      </div>
    </button>
  );
};

export default HeroButton;
